module.exports = __webpack_public_path__ + "static/img/screenshot-mob.6c27d9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/screenshot-mob.png
// module id = AkL+
// module chunks = 0